import PropTypes from 'prop-types'

const IconMail = ({ style }) => {
  return (
    <svg viewBox="0 0 32 32" fill="none" style={style}>
      <mask id="mask_mail" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
        <rect width="32" height="32" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask_mail)">
        <path d="M5.33317 26.6667C4.59984 26.6667 3.97206 26.4056 3.44984 25.8834C2.92762 25.3612 2.6665 24.7334 2.6665 24V8.00004C2.6665 7.26671 2.92762 6.63893 3.44984 6.11671C3.97206 5.59449 4.59984 5.33337 5.33317 5.33337H26.6665C27.3998 5.33337 28.0276 5.59449 28.5498 6.11671C29.0721 6.63893 29.3332 7.26671 29.3332 8.00004V24C29.3332 24.7334 29.0721 25.3612 28.5498 25.8834C28.0276 26.4056 27.3998 26.6667 26.6665 26.6667H5.33317ZM16.3498 17.05C16.4721 17.0167 16.5887 16.9667 16.6998 16.9L26.1332 11C26.3109 10.8889 26.4443 10.75 26.5332 10.5834C26.6221 10.4167 26.6665 10.2334 26.6665 10.0334C26.6665 9.58893 26.4776 9.2556 26.0998 9.03337C25.7221 8.81115 25.3332 8.82226 24.9332 9.06671L15.9998 14.6667L7.0665 9.06671C6.6665 8.82226 6.27761 8.81671 5.89984 9.05004C5.52206 9.28337 5.33317 9.61115 5.33317 10.0334C5.33317 10.2556 5.37761 10.45 5.4665 10.6167C5.55539 10.7834 5.68873 10.9112 5.8665 11L15.2998 16.9C15.4109 16.9667 15.5276 17.0167 15.6498 17.05C15.7721 17.0834 15.8887 17.1 15.9998 17.1C16.1109 17.1 16.2276 17.0834 16.3498 17.05Z" fill="white" fillOpacity="0.8"/>
      </g>
    </svg>
  )
}

IconMail.propTypes = {
  style: PropTypes.object,
}

export default IconMail
